export const LATERAL_VIEW_REQUIRED_NOTICE =
  'Classification requires at least one lateral view (Left or Right).';

type CapturedShot = { imageData?: string | null } | null | undefined;

/**
 * True when a frontal photo exists and neither Left nor Right does.
 * Does not change classification thresholds.
 */
export function captureLacksLateralView(
  captured:
    | {
        Anterior?: CapturedShot;
        Posterior?: CapturedShot;
        Left?: CapturedShot;
        Right?: CapturedShot;
      }
    | null
    | undefined,
): boolean {
  if (!captured) return false;
  const hasFrontal = Boolean(captured.Anterior?.imageData || captured.Posterior?.imageData);
  const hasLateral = Boolean(captured.Left?.imageData || captured.Right?.imageData);
  return hasFrontal && !hasLateral;
}
